import { render, staticRenderFns } from "./Prescriptionlistviewpopup.vue?vue&type=template&id=da20206c&scoped=true&"
import script from "./Prescriptionlistviewpopup.vue?vue&type=script&lang=js&"
export * from "./Prescriptionlistviewpopup.vue?vue&type=script&lang=js&"
import style0 from "./Prescriptionlistviewpopup.vue?vue&type=style&index=0&id=da20206c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da20206c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da20206c')) {
      api.createRecord('da20206c', component.options)
    } else {
      api.reload('da20206c', component.options)
    }
    module.hot.accept("./Prescriptionlistviewpopup.vue?vue&type=template&id=da20206c&scoped=true&", function () {
      api.rerender('da20206c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Prescription/Prescriptionlistviewpopup.vue"
export default component.exports